import React from 'react';
import styled from 'styled-components';
import { StyledTitle } from '../../SectionTwo/SectionTwoMain';
import { FlexContainer } from '../../../../styled/layout.styled';
import { Caption } from '../../../../styled/typograpghy.styled';
import Picture from '../../../reusable/Picture';
import commissionPlanImage from '../assets/Commission Plan Image.png';
import CommissionCard from './CommissionCard';
import { COMMISSION_PLAN_DATA } from '../../constant/constant';

const StyledBestCommissions = styled.h3`
  color: #22096c;
  margin-bottom: 16px;
  @media only screen and (max-width: 568px) {
    font-size: 24px;
  }
`;

const StyledCaption = styled(Caption)`
  color: #1f0d53;
`;

const StyledImageContainer = styled(FlexContainer)`
  @media only screen and (max-width: 568px) {
    display: none;
  }
`;

const CommissionPlans = () => (
  <FlexContainer
    flexDirection="column"
    mobileAlignItems="baseline"
    alignItems="center"
    padding="120px 0 302px 0"
    tabletPadding="60px 60px"
    mobilePadding="60px 24px"
  >
    <StyledTitle>COMMISSION PLANS</StyledTitle>
    <FlexContainer
      width="100%"
      maxWidth="900px"
      padding="60px 0 0 0"
      mobilePadding="32px 0 0 0"
      justifyContent="space-between"
      tabletJustifyContent="center"
      alignItems="center"
      flexWrap
      tabletFlexWrap
      mobileFlexWrap
    >
      <FlexContainer flexDirection="column" width="50%" tabletWidth="100%" tabletPadding="0 0 70px 0" mobilePadding="0">
        <StyledBestCommissions>BASED ON WAGER, NOT REVENUE PARTNER UP AND EARN UP TO 40%</StyledBestCommissions>
        <StyledCaption className="xlarge">
          We know you work hard, so Peergame Partners will reward you with some of the highest commissions in the online
          gaming industry
        </StyledCaption>
      </FlexContainer>
      <StyledImageContainer width="210px">
        <Picture img={commissionPlanImage} />
      </StyledImageContainer>
    </FlexContainer>
    <FlexContainer
      width="100%"
      maxWidth="900px"
      padding="60px 0 0 0"
      mobilePadding="40px 0 0 0"
      justifyContent="space-between"
      tabletFlexWrap
      mobileFlexWrap
    >
      {COMMISSION_PLAN_DATA.map(({
        id, bsv, percentage, height,
      }) => (
        <CommissionCard key={id} height={height} bsv={bsv} percentage={percentage} />
      ))}
    </FlexContainer>
  </FlexContainer>
);

export default CommissionPlans;
